<script lang="ts">
    import { Button, Col, Form, Row } from 'sveltestrap'
    import { BasicHTMLInputForm, Cancel, Submit, } from '../../../../utils/Constant/Constant';
    import Card from "../../../Core/Card.svelte";
    import BasicHtmlFormsInput from './BasicHtmlFormsInput.svelte';
    import BasicHtmlUrlInputs from './BasicHtmlUrlInputs.svelte';
    import BasicHtmlSimpleInput from './BasicHtmlSimpleInput.svelte';
</script>
  
<Card headerTitle={BasicHTMLInputForm} cardHeaderprops="pb-0" cardFooterprops="text-end" >
  <div slot="contentbody">
    <Form class="theme-form">
      <Row>
        <Col>
          <BasicHtmlSimpleInput />
          <BasicHtmlUrlInputs />
          <BasicHtmlFormsInput />
        </Col>
      </Row>
    </Form>
  </div>
  <div slot="contentfooter">
    <Button color="primary" class="me-2">{Submit}</Button>
    <Button color="light" type="reset">{Cancel}</Button>
  </div>
</Card>
  